import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=2a06548c&scoped=true&"
import script from "./MainCard.vue?vue&type=script&lang=ts&"
export * from "./MainCard.vue?vue&type=script&lang=ts&"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=2a06548c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06548c",
  null
  
)

export default component.exports